<template>
  <div>
    <dt>{{ label }}</dt>
    <dd>{{ options[value] }}</dd>
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-modalidade-ensino",
  props: {
    label: String,
    value: String
  },
  data() {
    return {
      options: {
        ["ead"]: "EAD",
        ["presencial"]: "Presencial"
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/ModalidadeEnsino.vue